import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "../../assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import ReactTable from "react-table";
import moment from "moment";
// Icons
//core components
import TextField from "@material-ui/core/TextField";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
// import CardIcon from "components/Card/CardIcon.jsx";
// import CardHeader from "components/Card/CardHeader.jsx";
// import Avatar from "@material-ui/core/Avatar";
// import IconButton from "@material-ui/core/IconButton";
// import Icon from "@material-ui/core/Icon";
// import Tooltip from "@material-ui/core/Tooltip";
// import Switch from "@material-ui/core/Switch";
import green from "@material-ui/core/colors/green";
import DeleteModel from "../../components/Common/FevoModels/DeleteModel";
import { getCustomerData } from "../../actions/customerActions";
import toastr from "toastr";
import axios from "axios";
import { domain } from "../../utils/util";

class ManagePayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showWarning: false,
      userToDeleteId: null,
      active: true,
      Data: null,
      id: null,
      showreject: false,
      search_event: "",
      data: null,
      declarationData: null,
    };
  }

  componentDidMount() {
    // this.props.fetchUsers()
    // this.props.getCustomerData();
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }
    axios
      .get(`${domain}/declaration/payment/list`, config)
      .then((res) => {
        if (res.data.statusCode === 200 || res.data.statusCode === 201) {
          //console.log("hiiiiiiii", res.data.data.data);
          this.setState({
            declarationData: res.data.data,
            Data: res.data.data,
          });
        } else if (res && res.data && res.data.statusCode === 401) {
          localStorage.removeItem("BerPay_Admin");
          this.props.history.push("/admin/pages/login-page");
        }
      })
      .catch((error) => {});
  }

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  getPaymentTableColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let self = this;
    // console.log("hiiiiii", this.props);
    let column = [
      {
        Header: "Profile Pic",
        accessor: "user.profile_pic",
        Cell: (props) => {
          if (
            props &&
            props.original &&
            props.original.user &&
            props.original.user.profile_pic
          ) {
            return (
              <span>
                <img
                  className={
                    props.original.user.profile_pic ? "profile_pic" : null
                  }
                  src={props.original.user.profile_pic}
                ></img>
              </span>
            );
          } else return <span></span>;
        },
      },
      {
        Header: "Username",
        //  Cell:(props)=>{
        //    return <span>{props.user.first_name}</span>
        //  }
        accessor: "user.user_name",
        Cell: ({ value }) => (value ? value : "NA"),
      },

      {
        Header: "First Name",
        accessor: "user.first_name",
        Cell: ({ value }) => (value ? value : "NA"),
      },
      {
        Header: "Middle Name",
        accessor: "user.middle_name",
        Cell: ({ value }) => (value ? value : "NA"),
      },
      {
        Header: "Last Name",
        accessor: "user.last_name",
        Cell: ({ value }) => (value ? value : "NA"),
      },

      {
        Header: "Source Type",
        accessor: "source.type",
        //  width: 160,
        Cell: ({ value }) => (value ? value : "NA"),
      },
      {
        Header: "Payment Type",
        width: 140,
        // accessor:"payment_for && declarations.name"
        Cell: (props) => {
          if (props && props.original) {
            switch (props.original.payment_for) {
              case "declaration":
                return <span>"declaration"</span>;

              case "wallet":
                return <span>Wallet Top Up</span>;

              case "wallet money transfer":
                return <span>P2P</span>;

              case "walletWithdrawal":
                return <span>Withdrawal</span>;

              default:
                return (
                  <span>
                    Deposit{" "}
                    {props.original.declarations &&
                      props.original.declarations.name}
                  </span>
                );
            }
          }
        },
      },

      // {
      //   Header: "Payment For",
      //   accessor: "payment_for",
      //   width: 140,
      //   Cell: ({ value }) => (value ? value : "NA"),
      // },
      // {
      //   Header: "payment_from ",
      //   accessor: "payment_from",
      //   width: 140,
      //   Cell: ({ value }) => (value ? value : "NA"),
      // },

      // {
      //   Header: "Recipient Picture",
      //   id: "recipient_profile_pic",
      //   width: 170,
      //   accessor: (row) => row.recipient_user?.profile_pic || "NA",
      //   Cell: ({ value }) =>
      //     value !== "NA" ? (
      //       <img src={value} alt="Profile" width={40} height={40} />
      //     ) : (
      //       "NA"
      //     ),
      // },
      // {
      //   Header: "Recipient Name",
      //   id: "recipient_name",
      //   width: 170,
      //   accessor: (row) => {
      //     const first = row.recipient_user?.first_name || "";
      //     const last = row.recipient_user?.last_name || "";
      //     return first || last ? `${first} ${last}`.trim() : "NA";
      //   },
      // },
      {
        Header: "Transaction Type",
        id: "transactionType",
        width: 170,
        accessor: (row) => row.wallet_logs?.payment_status || "NA",
      },
      {
        Header: "Currency",
        id: "currency",
        accessor: () => "USDC",
        Cell: ({ value }) => (value ? value : "NA"),
        width: 140,
      },

      {
        Header: "Amount",
        width: 120,
        accessor: "serverAmount",
        Cell: ({ value }) => (value ? value : "NA"),
        // Cell: (props) => {
        //   if (
        //     props &&
        //     props.original &&
        //     props.original.amount &&
        //     props.original.amount.amount
        //   ) {
        //     let num = props.original.amount.amount.split(".");
        //     let num2 = new Intl.NumberFormat("en-IN")
        //       .format(props.original.amount.amount)
        //       .split(".");
        //     if (num.length === 1) console.log(num2[0] + "." + num[1]);

        //     return <span>${num2[0] + "." + num[1]}</span>;
        //   } else {
        //     return <span></span>;
        //   }
        // },
      },
      {
        id: "Fees",
        Header: "Fees",
        accessor: "transaction_fee",
        Cell: ({ value }) =>
          value ? Math.abs(parseFloat(value).toFixed(2)) : "0.00",
      },

      {
        Header: "Date & Time",
        accessor: "createDate",
        width: 160,
        Cell: (props) => {
          return <span>{moment(props.original.createDate).format("LLL")}</span>;
        },
      },
      {
        Header: "Payment Status",
        accessor: "state",
        width: 170,
        Cell: ({ value }) => (value ? value : "NA"),
      },
      {
        Header: "Review",
        accessor: "reviewStatus",
        width: 170,
        Cell: ({ value, row }) => {
          const handleToggle = async () => {
            if (value) return; // prevent toggle if already reviewed

            const newValue = !value;
            let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
            let config = {};

            if (data) {
              config = {
                headers: {
                  Authorization: `Bearer ${data.token}`,
                  "Content-Type": "application/json",
                },
              };
            }

            const payload = {
              id: row._original._id,
              reviewStatus: true,
            };

            try {
              await axios.post(
                `${domain}/user/notifiction/payment/update`,
                payload,
                config
              );
              window.location.reload(); // Optional: replace with a state refresh
              console.log("Review status updated successfully");
            } catch (error) {
              console.error("Error:", error);
            }
          };

          return (
            <button
              onClick={handleToggle}
              disabled={value} // 🔒 disable if already reviewed
              style={{
                width: "120px",
                padding: "6px 12px",
                borderRadius: "6px",
                backgroundColor: value ? "#4CAF50" : "#F44336",
                color: "#fff",
                border: "none",
                cursor: value ? "not-allowed" : "pointer", // 🔒 cursor change
                fontWeight: 500,
                textAlign: "center",
              }}
            >
              {value ? "Reviewed" : "Unreviewed"}
            </button>
          );
        },
      },
    ];
    return column;
  };

  render() {
    const { classes } = this.props;
    const {
      showWarning,
      data,
      search_event,
      userToDeleteId,
      flightData,
      showreject,
      declarationData,
      Data,
    } = this.state;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardBody>
                <TextField
                  id="standard-search"
                  label="Search by Username, First Name, or Last Name"
                  name="search_event"
                  type="search"
                  fullWidth
                  value={search_event}
                  onChange={(event) => {
                    const { value } = event.target;
                    this.setState(
                      {
                        declarationData: Data,
                      },
                      () => {
                        const newwebinarData = this.state.declarationData.filter(
                          (item) =>
                            (item &&
                              item.user &&
                              item.user.user_name &&
                              item.user.user_name
                                .toLowerCase()
                                .includes(value.toLocaleLowerCase())) ||
                            (item &&
                              item.user &&
                              item.user.first_name &&
                              item.user.first_name
                                .toLowerCase()
                                .includes(value.toLocaleLowerCase())) ||
                            (item &&
                              item.user &&
                              item.user.last_name &&
                              item.user.last_name
                                .toLowerCase()
                                .includes(value.toLocaleLowerCase()))
                        );
                        this.setState({
                          declarationData: newwebinarData,
                          search_event: value.toLowerCase(),
                        });
                      }
                    );
                  }}
                  margin="normal"
                />
                <ReactTable
                  data={declarationData ? declarationData : []}
                  columns={this.getPaymentTableColumn()}
                  defaultPageSize={20}
                  pageSizeOptions={[5, 10, 20, 25, 50]}
                  showPaginationBottom={true}
                  minRows={4}
                  // manual
                  noDataText="No Records found"
                  onPageChange={(pageIndex) => {
                    console.log(pageIndex);
                    // let newQuery = getUserQuery;
                    // newQuery["offset"] = pageIndex * newQuery.limit;
                    // updateQueries(newQuery);
                    // getUserData(newQuery);
                  }}
                  onPageSizeChange={(rowPerPage) => {
                    console.log(rowPerPage);
                    // let newQuery = getUserQuery;
                    // newQuery["limit"] = rowPerPage;
                    // updateQueries(newQuery);
                    // getUserData(newQuery);
                  }}
                  // getTrProps={(state, rowInfo, column, instance) => {
                  //   return {
                  //     onClick: (e, handleOriginal) => {
                  //       if (rowInfo) {
                  //         // this.editCategoryFunc(rowInfo.original)
                  //       }
                  //     },
                  //     // style: {
                  //     //   cursor: 'pointer',
                  //     //   background: rowInfo && rowInfo.viewIndex%2 === 0 ? '#f9eddb' : '#e0d2be'
                  //     // }
                  //   };
                  // }}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>

        {/* <DeleteModel
          showModel={showreject}
          title={"Are you sure you want to delete this Flight?"}
          onCancel={() => {
            this.setState({
              showreject: false,
              id: null,
            });
          }}
          onOk={() => {
            let id = this.state.id;
            // let body = {
            //   id: id
            // };
            axios
              .delete(`${domain}/setting/flight/${id}`, config)
              .then((res) => {
                if (res.data.statusCode === 200 || res.data.statusCode === 201) {
                  toastr.success("Flight Deleted Successfully!");
                  this.setState({
                    showreject: false
                  })
                  setTimeout(function () {
                    window.location.reload();
                  }, 2000);
                }
              })
              .catch((error) => { });
          }}
        /> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // users: state.products.categories
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomerData: () => dispatch(getCustomerData()),
    // fetchCategories: ()=> dispatch(fetchCategories()),
    // categoryFormContent: (obj) => {dispatch({ type: PRODUCT_CATEGORY_ACTION.OPEN_CATEGORY_FORM, payload: obj })},
    // editCategory: (obj) => dispatch(editCategory(obj)),
    // deleteCategory: (obj,callback) => dispatch(deleteCategory(obj,callback)),
  };
};

const ManageCustumersComponent = withStyles(extendedTablesStyle)(ManagePayment);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCustumersComponent);
